import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var CustomText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  display: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  gap: ", ";\n  cursor: ", ";\n  white-space: ", ";\n  text-overflow: ", ";\n  overflow: ", ";\n  ", "\n"], ["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  display: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  gap: ", ";\n  cursor: ", ";\n  white-space: ", ";\n  text-overflow: ", ";\n  overflow: ", ";\n  ", "\n"])), function (_a) {
    var _b = _a.$color, $color = _b === void 0 ? "#000" : _b;
    return $color;
}, function (_a) {
    var _b = _a.$fontSize, $fontSize = _b === void 0 ? "14px" : _b;
    return "clamp(0.75rem, 4vw, ".concat($fontSize, ")");
}, function (_a) {
    var _b = _a.$fontSize, $fontSize = _b === void 0 ? "14px" : _b;
    return "calc(".concat($fontSize, " + 10px)");
}, function (_a) {
    var _b = _a.$fontWeight, $fontWeight = _b === void 0 ? "normal" : _b;
    return $fontWeight;
}, function (_a) {
    var _b = _a.$margin, $margin = _b === void 0 ? "0" : _b;
    return $margin;
}, function (_a) {
    var _b = _a.$padding, $padding = _b === void 0 ? "0" : _b;
    return $padding;
}, function (_a) {
    var _b = _a.$textAlign, $textAlign = _b === void 0 ? "left" : _b;
    return $textAlign;
}, function (_a) {
    var _b = _a.$textTransform, $textTransform = _b === void 0 ? "none" : _b;
    return $textTransform;
}, function (_a) {
    var _b = _a.$width, $width = _b === void 0 ? "auto" : _b;
    return $width;
}, function (_a) {
    var _b = _a.$display, $display = _b === void 0 ? "flex" : _b;
    return $display;
}, function (_a) {
    var _b = _a.$alignItems, $alignItems = _b === void 0 ? "center" : _b;
    return $alignItems;
}, function (_a) {
    var _b = _a.$justifyContent, $justifyContent = _b === void 0 ? "none" : _b;
    return $justifyContent;
}, function (_a) {
    var _b = _a.$gap, $gap = _b === void 0 ? "4px" : _b;
    return $gap;
}, function (_a) {
    var _b = _a.$cursor, $cursor = _b === void 0 ? "inherit" : _b;
    return $cursor;
}, function (_a) {
    var _b = _a.$whiteSpace, $whiteSpace = _b === void 0 ? "normal" : _b;
    return $whiteSpace;
}, function (_a) {
    var _b = _a.$textOverflow, $textOverflow = _b === void 0 ? "" : _b;
    return $textOverflow;
}, function (_a) {
    var _b = _a.$overflow, $overflow = _b === void 0 ? "" : _b;
    return $overflow;
}, function (_a) {
    var $isLink = _a.$isLink;
    return $isLink &&
        "\n      color: black;\n      cursor: pointer;\n\n      &:hover {\n        color: darkblue;\n        text-decoration: underline;\n      }\n    ";
});
var templateObject_1;
